<template>
        <!--主导航菜单-->
    <div class="navi">
        <el-row class="top-nav">
            <img src="../assets/logo.png">
            <span v-if="isProd == 'N'" style="line-height:15px; padding-top:7px " class="name">新美云平台
                <p  style="font-size:10px;text-align:center;color:red">[ 测 试 版 ]</p>
            </span>
            <span v-else style="line-height:15px; padding-top:10px " class="name">新美云平台
                <p  style="font-size:10px;text-align:center;color:red"></p>
            </span>
            <ul>
                <li v-for="item in nodes" 
                v-if="item.component == 'HomeView'" 
                @click="pushHandle(item.disable,item.path)" 
                :class="{'active':$route.matched[0].name == item.name,'disable':item.disable}">{{item.name}}</li>
            </ul>
            
        </el-row>
            
        <el-dialog
            title="提示"
            :visible.sync="isShowNoPass"
            width="30%">
            <span style="font-size: 18px;">您没有此项目菜单查看权限！</span>
            <span slot="footer" class="dialog-footer" style="text-align: center;">
                <el-button type="primary" @click="isShowNoPass = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import MenuUtils from '@/utils/MenuUtils'
    

    export default {
        components: {
           
        },
        data() {
            return {
                isProd:'',
                isActiveName:'', // 当前位置
                isShowNoPass:false,//无权限弹框
            }
        },
        created() {

            //这里没有直接使用this.$router.options.routes，是因为addRoute的路由规则，在这里this.$router.options.routes获取不到
            //有兴趣的可以看一下源码，是为什么获取不到，但是却又有规则了
            //另外在开发的时候，可能由于是热部署，也会不断重复的给nodes添加元素，造成导航条有重复的，简单解决，可以设置一个开关
            let inst = this;
            let data = JSON.parse(window.sessionStorage.getItem('userPre'))

            this.nodes = [];
            this.nodes.push(...data)
            // console.log(JSON.stringify(this.nodes))


        },
        methods: {
            
            pushHandle(disable,path){
                if(!disable){
                    this.$router.push(path)
                }else{
                    // this.isShowNoPass = true;
                }
            },
        },
        mounted() {
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
                this.isProd = user.isProd;
            }
        },

        computed: {
            
        },
    }

</script>

<style scoped lang="scss">
        .navi{
            position: fixed;
            top: 0;
            width: 100%;
            background-color: #fff;
            z-index: 999;
        }
        .top-nav{
            padding-left: 30px;
            height: 60px;
            line-height: 60px;
            border-bottom: solid 1px #eee;
            img{
                display: inline-block;
                vertical-align: middle;
                width: 36px;
                height: 36px;
            }
            .name{
                font-size: 18px;
                display: inline-block;
                vertical-align: middle;
                margin-left: 10px;
                font-weight: bold;
            }
            ul{
                display: inline-block;
                vertical-align: middle;
                overflow: hidden;
                font-size: 14px;
                margin: 0;
                padding-left: 40px;
                li{
                    float: left;
                    list-style: none;
                    padding: 0 15px;
                    cursor: pointer;
                    &.active{
                        color: #0077CC;
                        position: relative;
                        &::after{
                            content: "";
                            position: absolute;
                            border-bottom: solid 3px;
                            width: 60%;
                            bottom: 10px;
                            left: 50%;
                            margin-left: -30%;
                        }
                    }
                    &.disable{
                        color: #999;
                        cursor: default;
                    }
                }
            }
        }
</style>
<style>
.navi .el-dialog__footer{
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// Navi.vue?57e7633c